/* eslint formatjs/no-literal-string-in-jsx: "error" */
import React from "react"
import { Button, Icon, useFormContext } from "@carrotfertility/carotene"
import { useInAppMessaging } from "../context/messaging/InAppMessagingContext"
import { FormattedMessage, useIntl } from "react-intl"

type FormCancelButtonProps = { onClick: () => unknown }

export function FormCancelButton({ onClick }: FormCancelButtonProps): JSX.Element {
  const instance = useFormContext()
  function onClickFormCancel(): void {
    instance.setMeta(() => ({ isSubmitting: true }))
    onClick()
  }
  return (
    <Button variant="secondary" onClick={onClickFormCancel} disabled={instance?.meta?.isSubmitting}>
      <FormattedMessage defaultMessage="Cancel" />
    </Button>
  )
}

export function FormSendButton(): JSX.Element {
  const instance = useFormContext()
  const { selectedThread } = useInAppMessaging()
  const intl = useIntl()

  return (
    <Button
      type="submit"
      disabled={!instance?.meta?.canSubmit || instance?.values.message === "" || instance?.values.subject === ""}
    >
      {selectedThread?.isClosed
        ? intl.formatMessage({ defaultMessage: "Start follow-up" })
        : intl.formatMessage({ defaultMessage: "Send" })}
    </Button>
  )
}

export function FormSendNewMessageButton(): JSX.Element {
  const instance = useFormContext()

  return (
    <Button
      type="submit"
      disabled={!instance?.meta?.canSubmit || instance?.values.message === "" || instance?.values.subject === ""}
    >
      <FormattedMessage defaultMessage="Send" />
    </Button>
  )
}

export function FormSendIconButton(): JSX.Element {
  const instance = useFormContext()

  return (
    <Button
      type="submit"
      disabled={!instance?.meta?.canSubmit || instance?.values.message === "" || instance?.values.subject === ""}
      style={{
        borderRadius: "100%",
        padding: "12px"
      }}
    >
      <Icon name="upArrow" color="white" size="small" />
    </Button>
  )
}
